<mat-form-field [subscriptSizing]="subscriptSizing" class="chipAutocomplete full-width-form" color="accent">
	<!--SUFFIXES-->
	<mat-label>
		<ng-content select="[labelPrefix]" />
		{{ labelToken() | translate }}
	</mat-label>
	<div class="labelSuffix" matIconSuffix>
		<button (click)="onSearchButtonClick()" [disabled]="searchInput.disabled" appStopPropagation mat-icon-button>
			<mat-icon color="accent" fontIcon="fa-search" fontSet="fad" />
		</button>
		<ng-content select="[actions]" />
	</div>

	<!--AUTOCOMPLETE-->
	<mat-autocomplete #auto="matAutocomplete">
		@if (showSpinner()) {
			<mat-option class="busy" disabled />
		} @else {
			@if (filteredOptions().length) {
				@for (filteredOption of filteredOptions(); track filteredOption.id) {
					<mat-option (onSelectionChange)="handleSelect(filteredOption)" [value]="filteredOption">
						{{ filteredOption.label }}
					</mat-option>
				}
			} @else {
				<mat-option disabled>{{ T.AUTOCOMPLETE_NO_RESULTS | translate }}</mat-option>
			}
		}
	</mat-autocomplete>

	<!--INPUT-->
	<div class="inputRow">
		<mat-chip-grid #chipGrid [formControl]="errorCtrl" [required]="formCtrl()?.hasValidator(Validators.required) ?? false">
			@if (selectedOption) {
				<mat-chip-row (click)="onChipClick()" (removed)="removeSelection()" [value]="selectedOption" color="accent" highlighted>
					{{ selectedOption?.label }}
					<button matChipRemove>
						<mat-icon class="removeIcon" fontIcon="fa-times" fontSet="far" inline />
					</button>
				</mat-chip-row>
			}
		</mat-chip-grid>
		<input
			#searchInput
			#trigger="matAutocompleteTrigger"
			[formControl]="inputCtrl"
			[hidden]="!!selectedOption && !auto.isOpen"
			[matAutocomplete]="auto"
			[matChipInputAddOnBlur]="false"
			[matChipInputFor]="chipGrid"
			[matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			matInput
			placeholder="..."
		/>
	</div>

	<!--SUBSCRIPT-->
	<mat-error> {{ T.ERROR_SELECTION_REQUIRED | translate }} </mat-error>
</mat-form-field>
